import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { IProviderCost } from "./models/provider-cost";
import { IStructureCostForm } from "./models/structure-cost";

@Injectable({
  providedIn: "root"
})
export class CostService {
  private providersCostUrl: string = "/provider-cost";
  private StructureCostUrl: string = "/structure-cost";

  constructor(private http: HttpClient) {
  }

  async getProvidersCostList(month: number, year: number) {
    return this.http.get<IProviderCost[]>(`/provider-cost/${month}/${year}`).toPromise();
  }

  async createProviderCost(data: IProviderCost) {
    return this.http.post<IProviderCost>(this.providersCostUrl, data).toPromise();
  }

  async editProviderCost(id: number, data: IProviderCost) {
    return this.http.put<IProviderCost>(`${this.providersCostUrl}/${id}`, data).toPromise();
  }

  async updateStructureEmployeeCost(data: any) {
    return this.http.put(`/structure-cost/update-cost`, data).toPromise();
  }

  async uploadAttachmentCostProvider(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("POST", `/provider-cost/attachment/${id}`, formData);
    return this.http.request(req).toPromise();
  }

  async deleteAttachmentProviderCost(id: number) {
    return this.http.delete(`/provider-cost/attachment/${id}`).toPromise();
  }

  async deleteCostProvider(id: number) {
    return this.http.delete(`${this.providersCostUrl}/${id}`).toPromise();
  }

  async getStructureCostList(month: number, year: number) {
    return this.http.get<IProviderCost[]>(`/structure-cost/${month}/${year}`).toPromise();
  }

  async getStructureCostSingle(id: number) {
    return this.http.get<IProviderCost>(`/structure-cost/${id}`).toPromise();
  }

  async createStructureCost(data: IStructureCostForm) {
    return this.http.post<IStructureCostForm>(this.StructureCostUrl, data).toPromise();
  }

  async editStructureCost(id: number, data: IStructureCostForm) {
    return this.http.put<IStructureCostForm>(`${this.StructureCostUrl}/${id}`, data).toPromise();
  }

  async deleteCostStructure(id: number) {
    return this.http.delete(`${this.StructureCostUrl}/${id}`).toPromise();
  }

  async getStructureCostsByUser(user_hash: string, month: number = 0, year: number = 0) {
    month = month === 0 ? new Date().getMonth() + 1 : month;
    year = year === 0 ? new Date().getFullYear() : year;
    return this.http.get(`/structure-cost/user/${user_hash}/${month}/${year}`).toPromise();
  }
}
